(() => {
  'use strict';
  const bound = new WeakSet();
  const openers = new WeakMap();
  const routeKind = url => {
    if (url.origin !== location.origin) return null;
    if (/\/pages\/demander-un-devis\/?$/.test(url.pathname)) return url.searchParams.get('contact') === 'callback' ? 'callback' : 'quote';
    if (/\/pages\/cadeaux\/?$/.test(url.pathname)) return 'guide';
    return null;
  };
  const triggerKind = trigger => {
    if (trigger.dataset.ctoPopupOpen) return trigger.dataset.ctoPopupOpen;
    if (trigger.getAttribute('href')?.startsWith('#')) return null;
    try { return routeKind(new URL(trigger.href, location.href)); } catch { return null; }
  };
  const open = (kind, trigger, url) => {
    const dialog = document.querySelector(`[data-cto-popup="${kind}"]`);
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    document.querySelectorAll('dialog.cto-popup[open]').forEach(other => {
      if (other !== dialog) other.close();
    });
    const drawer = trigger?.closest('header-drawer');
    if (drawer?.closeMenuDrawer) drawer.closeMenuDrawer(new Event('click'));
    if (trigger) openers.set(dialog, trigger);
    const teamMenu = trigger?.closest('cto-team-contact')?.querySelector('details'); if (teamMenu) teamMenu.open = false;
    dialog.dispatchEvent(new CustomEvent('cto:popup-open', { detail: { service: url?.searchParams.get('service') || '', voyageOmra: trigger?.ctoVoyagePayload || null, returnForm: window.CTOFormReturn?.formId || '' } }));
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('cto-popup-lock');
    dialog.dispatchEvent(new CustomEvent('cto:popup-visible'));
    const result = [...dialog.querySelectorAll('[data-cto-inquiry-success], .cto-guide-success:not([hidden])')].find(node => !node.closest('[hidden]'));
    const target = result || [...dialog.querySelectorAll('[role="alert"], legend, select, input:not([type="hidden"]):not([tabindex="-1"])')].find(node => !node.closest('[hidden]') && !node.disabled);
    target?.focus({ preventScroll: true });
    return true;
  };
  const bind = () => {
    document.querySelectorAll('a[href], [data-cto-popup-open]').forEach(trigger => {
      const kind = triggerKind(trigger);
      if (!kind) return;
      if (kind === 'quote') {
        const url = new URL(trigger.href || location.href, location.href);
        if (['visa','visa-touristique'].includes(url.searchParams.get('service'))) { trigger.href = '/products/visa-arabie-saoudite#VisaPurchase'; return; }
      }
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-controls', kind === 'quote' ? 'CTOQuotePopup' : kind === 'callback' ? 'CTOCallbackPopup' : 'CTOGuidePopup');
    });
    document.querySelectorAll('dialog.cto-popup').forEach(dialog => {
      if (bound.has(dialog)) return;
      bound.add(dialog);
      dialog.querySelector('[data-cto-popup-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        if (!document.querySelector('dialog.cto-popup[open]')) document.documentElement.classList.remove('cto-popup-lock');
        const trigger = openers.get(dialog);
        if (trigger?.isConnected && trigger.getClientRects().length) trigger.focus({ preventScroll: true });
        else if (trigger?.closest('header-drawer')) trigger.closest('header-drawer').querySelector('summary')?.focus({ preventScroll: true });
      });
    });
  };
  document.addEventListener('click', event => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const trigger = event.target.closest?.('[data-cto-popup-open], a[href]');
    if (!trigger) return;
    const kind = triggerKind(trigger);
    if (!kind) return;
    let url;
    try { url = new URL(trigger.getAttribute('href') || location.href, location.href); } catch {}
    if (open(kind, trigger, url)) event.preventDefault();
  });
  bind();
  const current = new URL(location.href);
  const direct = routeKind(current);
  if (direct === 'quote' && ['visa','visa-touristique'].includes(current.searchParams.get('service'))) {
    location.replace('/products/visa-arabie-saoudite#VisaPurchase');
    return;
  }
  const returnId = window.CTOFormReturn?.formId || location.hash.slice(1);
  const returnedForm = returnId ? document.getElementById(returnId) : null;
  const returned = returnedForm?.querySelector('[data-cto-inquiry-success], [data-cto-inquiry-error]');
  const returnedKind = returnId === 'CallbackPopupForm' ? 'callback' : ['QuotePopupForm','OmraPlannerForm'].includes(returnId) ? 'quote' : null;
  const nativeSuccess = current.searchParams.get('contact_posted') === 'true';
  const inlineSuccess = [...document.querySelectorAll('main [data-cto-inquiry-success]')].some(node => !node.closest('dialog,[hidden]'));
  const recoveredQuote = nativeSuccess && !returnedKind && !inlineSuccess && document.querySelector('#OmraPlannerForm [data-cto-inquiry-success]');
  if (!window.Shopify?.designMode && (direct || returnedKind && (returned || window.CTOFormReturn) || recoveredQuote)) open(returnedKind && (returned || window.CTOFormReturn) ? returnedKind : recoveredQuote ? 'quote' : direct, null, current);
  document.addEventListener('shopify:section:load', bind);
})();
